import { render } from "./RequestAccepted.vue?vue&type=template&id=45dc5630&scoped=true"
import script from "./RequestAccepted.vue?vue&type=script&lang=js"
export * from "./RequestAccepted.vue?vue&type=script&lang=js"

import "./RequestAccepted.vue?vue&type=style&index=0&id=45dc5630&lang=scss&scoped=true"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45dc5630"]])

export default __exports__